import script from "./UniqueTableCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./UniqueTableCell.vue?vue&type=script&lang=ts&setup=true"

import "./UniqueTableCell.vue?vue&type=style&index=0&id=42124202&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42124202"]])

export default __exports__